module.exports = __webpack_public_path__ + "static/media/MH.8372ec12.png";